/**
 * Le V1 enregistre les caractères hors cp1252 (→, emoji…) sous forme d'entités
 * numériques HTML (`&#8594;`), que son affichage HTML interprète. React affiche
 * du texte brut : on décode ici les seules entités numériques, sans interpréter
 * de HTML.
 */
export function decodeNumericEntities(s: string): string {
  return s.replace(/&#(x[0-9a-f]+|\d+);/gi, (m, code: string) => {
    const n = code[0] === 'x' || code[0] === 'X' ? parseInt(code.slice(1), 16) : parseInt(code, 10);
    return Number.isFinite(n) && n > 0 && n <= 0x10ffff ? String.fromCodePoint(n) : m;
  });
}
